module.exports = "<div class=\"form-component\">\r\n  <div class=\"fc-column\">\r\n    <div [ngClass]=\"{'row':true, 'no-gutters': controlContext.spacing === 'noSpace'}\">\r\n      <div #panelContainer></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/containers/columns-designer-component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/layout/containers/columns-designer-component.html
// module chunks = main